import React from 'react';
import { useBacklogSelector } from '../../../../state';
import { backlogHasDueDate } from '../../../../state/selectors/cards';
import { DueDate as CardDueDate } from '../../card/card-contents/due-date';

type Props = {
	dueDate: string | null;
	isDone: boolean;
};

export const DueDate = (props: Props) => {
	const shouldRenderDueDateColumn = useBacklogSelector(backlogHasDueDate);

	return <CardDueDate {...props} shouldRenderDueDateColumn={shouldRenderDueDateColumn} />;
};
